import { Component, Input, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentRecord } from '@pulpo/pulpo-models';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import dayjs from 'dayjs';

//GiftCode Pipe
@Pipe({
  name: 'GiftCodePipe',
  standalone: true,
  pure: true,
})
export class GiftCodePipe implements PipeTransform {
  transform(
    giftCodes: { code: string; price: number; currency: string }[]
  ): string {
    return giftCodes.map((giftCode) => giftCode.code).join(', ');
  }
}

@Component({
  selector: 'booking-record-payment',
  templateUrl: './booking-record-payment.component.html',
  styleUrls: ['./booking-record-payment.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, GiftCodePipe],
})
export class BookingRecordPaymentComponent {
  dayjs = dayjs;
  @Input() paymentRecords: PaymentRecord[];
}
